import React from "react";
import moment from "moment";

import { DATE_FORMAT_FRONTEND } from "../../constants";
import TableBase from "./Base";

const ReportsOrdersByCompaniesTable = ({ scrollHeight, ordersByCompany, ...props }) => {
  const COLUMNS = [
    {
      title: "Company Name",
      dataIndex: "name",
      fixed: true,
      width: 150,
    },
    {
      title: "Created Date ",
      dataIndex: "createdAt",
      width: 150,
      render(value) {
        return value ? moment(value).format(DATE_FORMAT_FRONTEND) : "";
      },
    },
    {
      title: "Company Admin Email",
      dataIndex: "companyName",
      width: 300,
      ellipsis: true,
      render(_value, record) {
        return record.userAdmin?.email || "-";
      },
    },

    {
      title: "Orders Dispatched",
      key: "companyName",
      width: 300,
      ellipsis: true,
      render(record) {
        return ordersByCompany[record._id] || 0;
      },
    },
  ];
  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default ReportsOrdersByCompaniesTable;
